// Canonical destination list — order MUST match translations `destinations.list`
// and DESTINATION_ORDERED in images.js. Slugs are stable (used in URLs).
export const DESTINATIONS = [
  { slug: "mallorca", name: "Mallorca" },
  { slug: "ibiza", name: "Ibiza" },
  { slug: "formentera", name: "Formentera" },
  { slug: "marbella", name: "Marbella" },
  { slug: "monaco", name: "Monaco" },
  { slug: "saint-tropez", name: "Saint-Tropez" },
  { slug: "mykonos", name: "Mykonos" },
  { slug: "london", name: "London" },
  { slug: "paris", name: "Paris" },
  { slug: "dubai", name: "Dubai" },
  { slug: "switzerland", name: "Switzerland" },
  { slug: "marrakech", name: "Marrakech" },
  { slug: "sardinia", name: "Sardinia" },
  { slug: "amalfi", name: "Amalfi" },
  { slug: "st-barths", name: "St. Barths" },
  { slug: "maldives", name: "Maldives" },
  { slug: "courchevel", name: "Courchevel" },
];

export const destinationIndex = (slug) => DESTINATIONS.findIndex((d) => d.slug === slug);

export const interp = (str, name) => (str || "").replace(/\{name\}/g, name);
